//@flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type Props = {
  className?: string,
  dropDownName: string,
  dropDownContent: string,
  mode?: string,
};

const OutletFilterDropdown = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    dropDownName,
    className,
    dropDownContent,
    onClick,
    selectedDropDownOption,
    mode,
  } = props;

  const [isOpen, toggleOpen] = useState(false);
  const [bgColor, setBgColor] = useState('');
  const [textColor, setTextColor] = useState('');
  const containerClassNames = classNames(
    'dropdown-outlet-filter',
    mode,
    className
  );

  const onDropDownClick = () => {
    toggleOpen(!isOpen);
    setBgColor('#1c2023');
    setTextColor('#fff');
  };

  const handleClick = (location, index) => {
    onClick(location.outlet_slug, index);
    !isMobile && setBgColor('#1c2023');
  };

  const onOptionSelect = () => {
    toggleOpen(!isOpen);
    mode === 'dark' ? setBgColor('#1c2023') : setBgColor('');
  };

  // TODO: refactor
  if (dropDownContent) {
    return (
      <div className={containerClassNames} style={{ backgroundColor: bgColor }}>
        <button
          className={'dropdown-btn'}
          onClick={onDropDownClick}
          style={
            isOpen && !isMobile
              ? { backgroundColor: bgColor, color: textColor }
              : { color: '#000' }
          }
        >
          <div className={'btn-name'}>
            {dropDownName}{' '}
            {isOpen ? (
              <div className={'toggle-dropdown-up'} />
            ) : (
              <div className={'toggle-dropdown-down'} />
            )}
          </div>
        </button>
        {isOpen && (
          <div className={'dropdown-content'} onClick={onOptionSelect}>
            {dropDownContent.map((content, idx) => {
              const selectedClassOption =
                selectedDropDownOption === idx ? 'selected-option' : null;
              const contentClassNames = classNames(
                'dropdown-link',
                selectedClassOption
              );
              return (
                <div
                  key={idx}
                  className={contentClassNames}
                  onClick={() => handleClick(content, idx)}
                >
                  <div className={'content'}>
                    <div className={'name-number'}>
                      <div className={'name'}>{content.name}</div>
                      {content.phone && (
                        <div className={'number'}>{content.phone}</div>
                      )}
                    </div>
                    {!isMobile && (
                      <div className={'location'}>{content.location}</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default OutletFilterDropdown;
